import { render, staticRenderFns } from "./EducationCard.vue?vue&type=template&id=0a085d3a&"
import script from "./EducationCard.vue?vue&type=script&lang=js&"
export * from "./EducationCard.vue?vue&type=script&lang=js&"
import style0 from "./EducationCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports